import { z } from "zod";
import { trimmedString } from "./primitives";

export const workflowStatusSchema = z.enum([
  "pending",
  "in_progress",
  "done",
]);

export const updateWorkflowSchema = z.object({
  label: trimmedString.optional(),
  status: workflowStatusSchema.optional(),
});

export const applyWorkflowTemplateSchema = z.object({
  template: trimmedString,
});

export type UpdateWorkflowPayload = z.infer<typeof updateWorkflowSchema>;
export type ApplyWorkflowTemplatePayload = z.infer<
  typeof applyWorkflowTemplateSchema
>;
